import React, { useState, useEffect, useReducer } from 'react'
import get from 'lodash/get'

import Header from '../../components/FullWidthHeader'

import CreateContractInfo from './CreateContractInfo'
import CreateContract from './CreateContract'
import CreatedContract from './CreatedContract'

import AuthReducer, { authInitialState } from '../../store/reducers/auth'
import ContractReducer, { contractInitialState } from '../../store/reducers/contractReducer'
import PropositionReducer, { propositionInitalState } from '../../store/reducers/propostion'

import ContractContext from '../../store/contexts/contractContext'

import './contractcreation.scss'
import COLORS from '../../styles/colors'
import CONTRACT_STEPS from '../../constants/contract-steps'

import fetchCrawlerData from '../../services/fetch-crawler-data'
import finishSignup from '../../services/finish-signup'

import {
  authenticateUser,
  registerNewUser,
  requestConfirmationPin,
  verifyConfirmationPin,
  getUserBankAccount,
  createUserBankData,
} from '../../services/auth'

function ContractCreation() {
  const [authReducer, authDispatch] = useReducer(AuthReducer, authInitialState)
  const [contractReducer, contractDispatch] = useReducer(ContractReducer, contractInitialState)
  const [propositionReducer, propositionDispatch] = useReducer(PropositionReducer, propositionInitalState)

  const hasLoggedUser = !!localStorage.getItem('current_user')
  const [currentStep, setCurrentStep] = useState('Auth')
  const [step, setStep] = useState(hasLoggedUser ? CONTRACT_STEPS.CREATION : CONTRACT_STEPS.DESCRIPTION)
  const [isLoading, setIsLoading] = useState(false)

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    scrollToTop()
  }, [step])

  const handleStepChange = (step, clickable) => {
    const isString = typeof step === 'string'
    const destination = isString ? step : step.id

    if (!isString && !clickable) {
      return
    }

    setCurrentStep(destination)
  }

  const customSignup = async (data, facebookToken) =>
    finishSignup(
      announcementId,
      { source, sourceId, token },
      { data, facebookToken, conversionFrom: 'contract-web' },
    )

  const context = {
    auth: {
      ...authReducer,
      authDispatch,
    },
    contract: {
      ...contractReducer,
      contractDispatch,
    },
    proposition: {
      ...propositionReducer,
      propositionDispatch,
    },
    services: {
      authenticateUser,
      registerNewUser,
      customSignup,
      requestConfirmationPin,
      verifyConfirmationPin,
      getUserBankAccount,
      createUserBankData,
    },
    handleStepChange,
    currentStep,
    setStep,
    isLoading,
    setIsLoading,
  }

  const urlParams = new URLSearchParams(window.location.search)
  /* Legacy conversion params. Can be removed in the near future when no more links depend on it */
  const sourceId = urlParams.get('signup_id')
  const source = urlParams.get('signup_source') || 'olx'
  /* */
  const announcementId = urlParams.get('signup_ref')
  const token = urlParams.get('token')

  const [urlData, setUrlData] = useState()
  useEffect(() => {
    async function fetchData() {
      if (urlData === undefined) {
        if (!sourceId && !announcementId) {
          setUrlData(null)
          return
        }

        try {
          const { rawAnnouncement } = await fetchCrawlerData(announcementId, {
            source,
            sourceId,
            token,
          })

          setUrlData({
            name: get(rawAnnouncement, 'editable.landlord_name', ''),
            phone: get(rawAnnouncement, 'editable.landlord_phone', ''),
          })
        } catch (error) {
          setUrlData(null)
        }
      }
    }
    fetchData()
  }, [announcementId, source, sourceId, token, urlData]) // eslint-ignore

  return (
    <div className='create-contract-container'>
      <ContractContext.Provider value={context}>
        <div className='header-spacer'>
          <Header breakTextMarker='!' title={'Gerador de ! contrato de aluguel'} />
        </div>

        {step === CONTRACT_STEPS.DESCRIPTION && (
          <CreateContractInfo onClick={() => setStep(CONTRACT_STEPS.CREATION)} />
        )}
        {step === CONTRACT_STEPS.CREATION && <CreateContract urlData={urlData} />}
        {step === CONTRACT_STEPS.FINISHED && <CreatedContract />}

        <footer className='contract-creation-container'>
          <section className='QA-section'>
            <div className='question'>
              <span className='bold'>VAMOS CONVERSAR ?</span>
              <span className='QA-info'>contato@mellro.com</span>
              <span className='QA-info'>(41) 98788-9368</span>
            </div>
            <div className='question'>
              <span className='bold'>ONDE ESTAMOS ?</span>
              <span className='QA-info'>Fazemos o Mellro com carinho em Curitiba, no Paraná</span>
            </div>
          </section>
          <span className='copyright-symbol'>&copy; Mellro All Rights Reserved</span>
        </footer>
      </ContractContext.Provider>
    </div>
  )
}

export const contractCreationStyles = {
  sectionTitle: {
    color: COLORS.brand.secondary,
    fontWeight: 800,
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 16,
  },
  container: {
    display: 'flex',
  },
  separator: {
    margin: 30,
  },
}

export default ContractCreation
